import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import * as _ from 'lodash';
import { TaskStatuses } from '../task.constants';
import { ITask } from '../task.interface';
import { TaskHttpService } from '../task-http.service';
import { UtilsService } from '../../../../shared/services/utils.service';

@Component({
  selector: 'app-schedule-sel',
  templateUrl: './task-schedule.component.html',
  styleUrls: ['./task-schedule.component.css']
})
export class TaskScheduleComponent implements OnInit {
  dialog: MatDialogRef<any>;
  loading: boolean = false;
  saving: boolean = false;
  submitted = false;
  task!: ITask;
  form!: UntypedFormGroup;
  taskStatuses: any = TaskStatuses;
  taskStatusesKeys = Object.keys(TaskStatuses);
  newStatus!: string;
  readOnly: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<any>,
    public _TaskHttpService: TaskHttpService,
    private _UtilsService: UtilsService,
    private fb: UntypedFormBuilder,
  ) {
    this.dialog = dialogRef;
  }

  ngOnInit() {
    console.log(this.newStatus);
    this.getTask();
  }

  getTask() {
    this.loading = true;
    this._TaskHttpService.getTask(this.task._id || '').subscribe(async (task) => {
      this.task = task;
      this.buildForm();
      this.loading = false;
    });
  }

  get f() { return this.form.controls; }
  buildForm() {
    const scheduledStart = this.task.scheduledStart ? this._UtilsService.date.toLocale(this.task.scheduledStart as any) : '';
    const scheduledEnd = this.task.scheduledEnd ? this._UtilsService.date.toLocale(this.task.scheduledEnd as any) : '';
    this.form = this.fb.group({
      title: [this.task.title],
      status: [this.newStatus],
      scheduledStart: [scheduledStart, [scheduledStartValidator]],
      scheduledEnd: [scheduledEnd],
    }, { validators: [scheduledBothDatesRequiredOrNull(), scheduledStartLowerThanEnd(), scheduledStatusBothDatesRequired()] });
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) return;
    this.saving = true;
    let data: any = _.cloneDeep(this.form.value);

    data._id = this.task._id;
    data.company = _.get(this.task, 'company._id');

    if (data.scheduledStart) data.scheduledStart = new Date(data.scheduledStart).toISOString();
    else delete data.scheduledStart;
    if (data.scheduledEnd) data.scheduledEnd = new Date(data.scheduledEnd).toISOString();
    else delete data.scheduledEnd;

    this._TaskHttpService.updateTask(data).subscribe((task: any) => {
      this.dialog.close(task);
    });

    /*
    delete data.newProduct;
    data.company = this._AuthService.companyId();
    data.products = this.productItems.map(item => {
      return { product: item.product._id, quantity: item.quantity, price: item.product.price }
    });

    if (data.scheduledAt) data.scheduledAt = new Date(data.scheduledAt).toISOString();
    else delete data.scheduledAt;
    if (data.scheduledStart) data.scheduledStart = new Date(data.scheduledStart).toISOString();
    else delete data.scheduledStart;
    if (data.scheduledEnd) data.scheduledEnd = new Date(data.scheduledEnd).toISOString();
    else delete data.scheduledEnd;

    // console.log(data);
    // return;

    if (this.task._id) {
      data._id = this.task._id;
      data.client = data.client._id;
      this._TaskHttpService.updateTask(data).subscribe((task: any) => {
        this.dialog.close(task);
      });
    } else {
      data.client = data.client._id;
      this._TaskHttpService.createTask(data).subscribe((task: any) => {
        this.dialog.close(task);
      });
    } */
  }

  scheduledStartChange() {
    if (this.f['scheduledStart'].value && !this.task.scheduledEnd) {
      const start: any = this.f['scheduledStart'].value;
      const start_: any = this._UtilsService.date.addHours(start, 1);
      const date = this._UtilsService.date.toLocale(start_.toISOString());
      this.f['scheduledEnd'].setValue(date)
    }
  }
}

function scheduledStartValidator(control: AbstractControl): any {
  if (control.value && (new Date(control.value).getTime() < (new Date().getTime() - (365 * 24 * 60 * 60 * 1000)))) {
    return { tooEarly: true };
  }
}

function scheduledBothDatesRequiredOrNull() {
  return (group: UntypedFormGroup) => {
    let startControl = group.controls['scheduledStart'];
    let endControl = group.controls['scheduledEnd'];
    if (!startControl.value && endControl.value) startControl.setErrors({ bothRequired: true })
    if (startControl.value && !endControl.value) endControl.setErrors({ bothRequired: true })
  }
}

function scheduledStartLowerThanEnd() {
  return (group: UntypedFormGroup) => {
    let startControl = group.controls['scheduledStart'];
    let endControl = group.controls['scheduledEnd'];
    if (startControl.value > endControl.value) endControl.setErrors({ lowerThanStart: true })
  }
}

function scheduledStatusBothDatesRequired() {
  return (group: UntypedFormGroup) => {
    let statusControl = group.controls['status'];
    let startControl = group.controls['scheduledStart'];
    let endControl = group.controls['scheduledEnd'];
    if (statusControl.value == 'SCHEDULED' && (startControl.value == '' || endControl.value == '')) {
      statusControl.setErrors({ datesRequired: true })
    } else {
      statusControl.setErrors(null);
    }
  }
}